import * as React from "react";
import { forwardRef } from "react";
const SvgBridCorrect = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M7 .333c3.682 0 6.667 2.985 6.667 6.667S10.682 13.667 7 13.667.333 10.682.333 7 3.318.333 7 .333zm4.122 3.846c-.27-.25-.691-.236-.943.033L5.95 8.745 4.1 7.16c-.28-.24-.7-.207-.94.073-.24.28-.208.7.072.94l2.333 2c.271.232.678.21.921-.051l4.667-5c.251-.27.237-.691-.032-.943z" }));
const ForwardRef = forwardRef(SvgBridCorrect);
export { ForwardRef as ReactComponent };
